// extracted by mini-css-extract-plugin
export var cardHeader = "_tw-0";
export var reorderHandle = "_tw-3";
export var titleArea = "_tw-1";
export var titleAreaWithHandle = "_tw-2";